// carwash-product.jsx
import React, { useState } from "react";
import { AnimateOnScroll } from "./AnimateOnScroll";
import { useContactForm } from "./ContactContext";

const productMedia = [
  { type: "image", src: "/images/carwash-sec/red-machine2.webp" },
  { type: "image", src: "/images/carwash-sec/red-machine.webp" },
  { type: "image", src: "/images/carwash-sec/c2-1.webp" },
  { type: "image", src: "/images/carwash-sec/c2.webp" },
  { type: "video", src: "/images/carwash-sec/vid1.mp4" },
  { type: "video", src: "/images/carwash-sec/vid2.mp4" },
];

const specs = [
  { icon: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z", label: "21.5 inch antiglare touch screen display" },
  { icon: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm0 8a1 1 0 011-1h6a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h6a1 1 0 110 2H5a1 1 0 01-1-1zm8-4a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zm0 4a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z", label: "Multiple screen flow configurations with custom design" },
  { icon: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z M15 13a3 3 0 11-6 0 3 3 0 016 0z", label: "License Plate Recognition" },
  { icon: "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0", label: "RFID access" },
  { icon: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z", label: "QR Code Reader and receipt printer" },
  { icon: "M15.536 8.464a5 5 0 010 7.072M12 6v6m0 0v6m0-6h6m-6 0H6M9.172 16.172a4 4 0 015.656 0M6.343 9.657a8 8 0 0111.314 0", label: "Built in speaker for instructional prompts" },
  { icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z", label: "Cash box with lockable security door" },
  { icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z", label: "Security door with integrated sleek locking system" },
];

const specTable = [
  { label: "Material", value: "Stainless Steel enclosure" },
  { label: "Voltage", value: "110V" },
  { label: "Dimensions", value: '16.825" D × 26.5" W × 65.25" H' },
  { label: "Door dimensions", value: '21" × 36"' },
];

export const CarwashProduct = () => {
  const { open } = useContactForm();
  const [selected, setSelected] = useState(0);

  return (
    <>
    <style>{`
      @keyframes kCustomGradient {
        0%   { background-position: 0% 50%; }
        50%  { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `}</style>
    <section className="bg-white py-20 px-6 lg:px-8">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">

          {/* Gallery */}
          <AnimateOnScroll direction="right" className="flex flex-col gap-3 w-full lg:w-auto">
            <div className="flex gap-4 w-full lg:w-auto">
              {/* Thumbnails: misma altura que el visor; si no caben, scroll vertical */}
              <div className="flex flex-col gap-4 flex-shrink-0 overflow-y-auto hide-scrollbar h-[320px] sm:h-[500px] md:h-[560px] lg:h-[520px]">
                {productMedia.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => setSelected(index)}
                    className={`w-[72px] h-[72px] sm:w-[90px] sm:h-[90px] rounded-xl overflow-hidden border-2 transition-all duration-200 flex-shrink-0 relative ${
                      selected === index ? "border-[#1a1f6c]" : "border-transparent"
                    }`}
                  >
                    {item.type === "video" ? (
                      <>
                        <video src={item.src} className="w-full h-full object-cover" muted preload="metadata" />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </>
                    ) : (
                      <img src={item.src} alt={`Car wash pay station, view ${index + 1}`} className="w-full h-full object-cover" />
                    )}
                  </button>
                ))}
              </div>

              {/* Main image */}
              <div className="relative flex-1 lg:w-[420px] lg:flex-none h-[320px] sm:h-[500px] md:h-[560px] lg:h-[520px] rounded-2xl overflow-hidden bg-gray-100">
                {productMedia[selected].type === "video" ? (
                  <video
                    key={productMedia[selected].src}
                    src={productMedia[selected].src}
                    className="w-full h-full object-cover"
                    controls
                    autoPlay
                    muted
                    playsInline
                  />
                ) : (
                  <div
                    className="w-full h-full cursor-zoom-in group"
                    onMouseMove={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = ((e.clientX - rect.left) / rect.width) * 100;
                      const y = ((e.clientY - rect.top) / rect.height) * 100;
                      e.currentTarget.querySelector("img").style.transformOrigin = `${x}% ${y}%`;
                    }}
                  >
                    <img
                      src={productMedia[selected].src}
                      alt="Kinitas Kiosk"
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-150"
                    />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                      <div className="bg-black/40 rounded-full p-2">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Custom colors button */}
            <button
              style={{
                background: "linear-gradient(135deg, #0f1654, #1a1f6c, #2832c2, #4f46e5, #7c3aed, #2832c2, #1a1f6c)",
                backgroundSize: "400% 400%",
                animation: "kCustomGradient 22s ease infinite",
                textShadow: "0 1px 3px rgba(0,0,0,0.25)",
              }}
              className="w-full py-3 px-6 rounded-lg text-white font-medium text-sm tracking-wide transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98]"
            >
              Custom Colors and Design Available
            </button>
          </AnimateOnScroll>

          {/* Info con scroll interno */}
          <AnimateOnScroll direction="left" delay={0.2} className="flex-1 w-full lg:max-w-xl">
            <div className="flex flex-col h-full">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#111827] leading-tight mb-2">
                Kinitas Car Wash Pay Station
              </h2>
              <p className="text-sm sm:text-base text-[#6b7280] leading-relaxed mb-4">
                Built for independent car wash owners who want to run fully automated — no attendant, no cash handling headaches. Accept cash and credit, sell memberships, gift cards, and wash books, run video ads between transactions, and automatically capture customer phone numbers to grow your SMS marketing list.
              </p>

              {/* Scroll container */}
              <div
                className="overflow-y-auto pr-2 flex-1"
                style={{
                  maxHeight: "340px",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#1a1f6c22 transparent",
                }}
              >
                {/* Features list */}
                <ul className="space-y-3 mb-6">
                  {specs.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-[#374151]">
                      <div className="w-8 h-8 rounded-lg bg-[#f0f2ff] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <svg className="w-4 h-4 text-[#1a1f6c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                        </svg>
                      </div>
                      <span className="leading-relaxed pt-1">{item.label}</span>
                    </li>
                  ))}
                </ul>

                {/* Specs table */}
                <div className="rounded-xl overflow-hidden border border-gray-100 mb-4">
                  <div className="bg-[#f5f7ff] px-4 py-2">
                    <p className="text-xs font-semibold uppercase tracking-widest text-[#1a1f6c]">Specifications</p>
                  </div>
                  {specTable.map((row, i) => (
                    <div key={i} className={`flex px-4 py-2.5 text-sm ${i % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
                      <span className="w-40 text-[#6b7280] font-medium flex-shrink-0">{row.label}</span>
                      <span className="text-[#111827]">{row.value}</span>
                    </div>
                  ))}
                </div>

                {/* Features coming soon */}
                <div className="rounded-xl border border-[#e0e4ff] bg-[#f5f7ff] px-4 py-4 mb-4">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-xs font-semibold uppercase tracking-widest text-[#1a1f6c]">Features</span>
                    <span className="text-[10px] font-medium bg-[#1a1f6c] text-white rounded-full px-2 py-0.5 leading-none">Coming Soon</span>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    {[
                      { label: "Loyalty", emoji: "🎯" },
                      { label: "Campaigns", emoji: "📣" },
                      { label: "Multi-site", emoji: "🌐" },
                    ].map((feat) => (
                      <div
                        key={feat.label}
                        className="flex items-center gap-1.5 bg-white border border-[#d1d8ff] rounded-lg px-3 py-1.5 text-sm font-medium text-[#1a1f6c] shadow-sm"
                      >
                        <span>{feat.emoji}</span>
                        <span>{feat.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="in-line gap-4 mt-6 flex">
                <button
                  type="button"
                  onClick={() => open({ intent: "leasing", product: "Car Wash Pay Station", industry: "car-wash", source: "Leasing Available" })}
                  className="mt-4 inline-flex items-center justify-center border border-[#1a1f6c] text-[#1a1f6c] font-medium rounded-lg px-7 py-3 hover:bg-[#1a1f6c]/5 transition-colors duration-300 w-fit"
                >
                  Leasing Available
                </button>
                <button
                  type="button"
                  onClick={() => open({ intent: "quote", product: "Car Wash Pay Station", industry: "car-wash", source: "Request a Quote" })}
                  className="mt-4 inline-flex items-center justify-center bg-[#1a1f6c] text-white font-medium rounded-lg px-7 py-3 hover:bg-[#2832c2] transition-colors duration-300 w-fit"
                >
                  Request a Quote
                </button>
              </div>
              
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>
    </>
  );
};